import { render, staticRenderFns } from "./LegacyBeginOrderForm.vue?vue&type=template&id=ecf85cfc&"
import script from "./LegacyBeginOrderForm.vue?vue&type=script&lang=js&"
export * from "./LegacyBeginOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports